/**
 * category == activity
 */
export default function SearchBarActivity() {
    return {
        restrict: "E",
        //require : '^searchBar',
        template: require("./template.html"),

        controller: function ($scope) {
            /**
             * note: No Scope defined -> aka same as parent
             */

            $scope.$watch("oSearchCategory.input", function (userInput) {
                //avail paramas  : userInput, oldVar

                $scope.exactMatchFilter(userInput);
            });

            $scope.highlightChars = function (obj, userInputLowerCase) {
                var chars = [];

                angular.forEach(obj.Name, function (char, key) {
                    var oChar = {
                        name: char,
                        exact: false,
                    };

                    if (userInputLowerCase[key] == obj.NameLowerCase[key]) {
                        oChar.exact = true;
                    } else {
                        oChar.exact = false;
                    }

                    chars.push(oChar);
                });

                return chars;
            };

            $scope.exactMatchFilter = function (userInput) {
                if (userInput) {
                    $scope.collection = angular.copy(
                        $scope.oSearchCategory.housecategorieslight
                    );

                    var result = {
                        filterInUse: null,
                        matches: [],
                        exactMatches: [],
                        withoutExactMatches: [],
                    };

                    if ($scope.collection) {
                        $scope.collection.forEach(function (obj) {
                            // console.log(obj.Name + '  = ' + userInput);

                            obj.matches = {
                                partly: false,
                                exact: false,
                            };

                            // console.log(  obj.Name.indexOf(userInput));
                            obj.NameLowerCase = obj.Name.toLowerCase();

                            var userInputLowerCase = userInput.toLowerCase();

                            var substringIndex =
                                obj.NameLowerCase.indexOf(userInputLowerCase);

                            if (substringIndex !== -1) {
                                //obj.chars = $scope.highlightChars(obj, userInputLowerCase);

                                obj.matches.partly = true;

                                result.matches.push(obj);

                                if (substringIndex == 0) {
                                    obj.matches.exact = true;

                                    result.exactMatches.push(obj);
                                } else {
                                    result.withoutExactMatches.push(obj);
                                }
                            } else {
                                obj.matches = null;
                            }
                        });
                    }

                    result.filterInUse = result.exactMatches;

                    $scope.oSearchCategory.filteredItems = result;
                } else {
                    //console.log('no input');
                }
            };
        },
    };
}
